export default __webpack_public_path__ + "static/icon_menu_series-1.0.0.png";